import type { TaskboardData } from '@/content/types';

export default function Taskboard(props: TaskboardData) {
  return (
    <section className="section-padding">
      <div className="container split-2col">
        <div>
          {props.eyebrow && (
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '6px 12px', borderRadius: 999,
              background: '#fff', fontSize: 12, fontWeight: 600,
              marginBottom: 24,
            }}>
              ● {props.eyebrow}
            </div>
          )}
          <h2 className="h-feature">{props.title}</h2>
          <p style={{ marginTop: 16, color: 'var(--color-muted)' }}>{props.body}</p>
          <ul style={{ marginTop: 20, paddingLeft: 20 }}>
            {props.bullets.map((b, i) => <li key={i} style={{ marginBottom: 8 }}>{b}</li>)}
          </ul>
          {props.cta && (
            <a href={props.cta.href} className="btn-primary" style={{ marginTop: 24 }}>
              {props.cta.label}
            </a>
          )}
        </div>
        <div>
          <img src={props.image.src} alt={props.image.alt} width={props.image.width} height={props.image.height} loading="lazy" decoding="async" style={{ borderRadius: 24, width: '100%', height: 'auto' }} />
        </div>
      </div>
    </section>
  );
}
